import { render, staticRenderFns } from "./LinkPageBack.vue?vue&type=template&id=6b157a3c&"
import script from "./LinkPageBack.vue?vue&type=script&lang=js&"
export * from "./LinkPageBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports